export const EMBOSS_MAX_LENGTH = 20
export const EMBOSS_MIN_LENGTH = 2
export const GREETING_CARD_CARRIER_TO_MAX_LENGTH = 50
export const GREETING_CARD_CARRIER_FROM_MIN_LENGTH = 2
export const GREETING_CARD_CARRIER_FROM_MAX_LENGTH = 26
export const GREETING_CARD_CARRIER_MESSAGE_MIN_LENGTH = 2
export const GREETING_CARD_CARRIER_MESSAGE_MAX_LENGTH = 120

export const GREETING_CARD_HANDWRYTTEN_CARRIER_TO_MAX_LENGTH = 50
export const GREETING_CARD_HANDWRYTTEN_CARRIER_FROM_MIN_LENGTH = 2
export const GREETING_CARD_HANDWRYTTEN_CARRIER_FROM_MAX_LENGTH = 26
export const GREETING_CARD_HANDWRYTTEN_CARRIER_MESSAGE_MIN_LENGTH = 2
export const GREETING_CARD_HANDWRYTTEN_CARRIER_MESSAGE_MAX_LENGTH = 150

export const STANDARD_CARRIER_TO_MAX_LENGTH = 50
export const STANDARD_CARRIER_FROM_MIN_LENGTH = 2
export const STANDARD_CARRIER_FROM_MAX_LENGTH = 26
export const STANDARD_CARRIER_MESSAGE_MIN_LENGTH = 2
export const STANDARD_CARRIER_MESSAGE_MAX_LENGTH = 120
export const EMAIL_CARRIER_TO_MAX_LENGTH = 50
export const EMAIL_CARRIER_FROM_MIN_LENGTH = 2
export const EMAIL_CARRIER_FROM_MAX_LENGTH = 50
export const EMAIL_CARRIER_MESSAGE_MIN_LENGTH = 2
export const EMAIL_CARRIER_MESSAGE_MAX_LENGTH = 120
export const EMAIL_CARRIER_EMAIL_MAX_LENGTH = 255
